<template>
  <BaseModal
    v-if="currentUser"
    :modalTitle="$t('W: Opdater PIN-kode')">
    <EmployeeEditPinCodeView :user="currentUser" />
  </BaseModal>
</template>

<script lang="ts">
import { useUserStore } from '@/stores/userStore'
import { mapState } from 'pinia'

export default {
  name: 'UpdatePinCodeModal',

  emits: ['close'],

  computed: {
    ...mapState(useUserStore, ['currentUser']),
  },
}
</script>
